import { SxProps, Theme } from "@mui/material";

export const loginContainerSx: SxProps<Theme> = (theme) => ({
  minHeight: "100dvh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: theme.palette.loginBg,
});

export const paperSx: SxProps<Theme> = (theme) => ({
  "--Paper-overlay": "none !important",
  width: "100%",
  maxWidth: 500,
  borderRadius: "32px",
  backgroundColor: theme.palette.panelInfo.panel.bg,
  p: "48px",
});

export const titleSx: SxProps<Theme> = (theme) => ({
  color: theme.palette.header.titalColor,
  marginBottom: "16px",
  fontFamily: '"Red Hat Display", sans-serif',
  fontWeight: 600,
  fontSize: "32px",
  lineHeight: 1.334,
  textAlign: "left",
});

export const formSx: SxProps<Theme> = (theme) => ({
  display: "flex",
  flexDirection: "column",
  gap: 2,
});

export const labelSx: SxProps<Theme> = (theme) => ({
  color: "#06B6D4",
  fontSize: "18px",
  fontWeight: 600,
});

export const passwordBoxSx: SxProps<Theme> = {
  position: "relative",
};

export const buttonSubmitSx: SxProps<Theme> = (theme) => ({
  textTransform: "none",
  py: "16px",
  fontWeight: "bold",
  background: "linear-gradient(90deg, #28C9DC 0%, #8957CF 100%)",
  color: "#ffffff",
  borderRadius: "999px",
  "&:hover": {
    background: "linear-gradient(90deg, #20B6C8 0%, #7C4ABF 100%)",
    color: "#ffffff",
  },
  cursor: "pointer",
});

export const textFieldSx: SxProps<Theme> = (theme) => ({
  "& .MuiOutlinedInput-root": {
    marginTop: "8px",
    borderRadius: "999px",
    backgroundColor: theme.palette.input.bgColor,
    overflow: "hidden",
    "& .MuiOutlinedInput-input": {
      "&:-webkit-autofill": {
        boxShadow: "0 0 0 1000px transparent inset !important",
        WebkitBoxShadow: "0 0 0 1000px transparent inset !important",
        WebkitTextFillColor: theme.palette.text.primary + " !important",
        animationName: "none !important",
        animationDuration: "0s !important",
        animationDelay: "0s !important",
        transition: "background-color 99999s ease-in-out 0s !important",
      },
      "&:-webkit-autofill:hover, &:-webkit-autofill:focus": {
        boxShadow: "0 0 0 1000px transparent inset !important",
        WebkitBoxShadow: "0 0 0 1000px transparent inset !important",
        WebkitTextFillColor: theme.palette.text.primary + " !important",
        animationName: "none !important",
        animationDuration: "0s !important",
        animationDelay: "0s !important",
        transition: "background-color 99999s ease-in-out 0s !important",
      },
    },

    "& fieldset": {
      borderRadius: "999px",
    },

    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.input.borderColorHover,
    },

    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.input.borderColorHover,
      paddingRight: "20px",
    },
  },
});
